import { POPUP_STORAGE_KEY } from './constants'
import { type PopupData } from './types'

export class PopupStorage {
  private readonly _blockId: string

  constructor(blockId: string) {
    this._blockId = blockId
  }

  private parseData(data: string | null): PopupData | null {
    if (!data) {
      return null
    }

    try {
      const obj = JSON.parse(data ?? '{}')
      return obj
    } catch (error) {
      return null
    }
  }

  public saveData(data: PopupData): void {
    try {
      localStorage.setItem(
        `${POPUP_STORAGE_KEY}-${this._blockId}`,
        JSON.stringify(data),
      )
    } catch (e) {}
  }

  public loadData(): PopupData | null {
    try {
      return this.parseData(
        localStorage.getItem(`${POPUP_STORAGE_KEY}-${this._blockId}`),
      )
    } catch (e) {
      return null
    }
  }
}
